import { useEventCallback } from '@mui/material';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { useDataGridContext } from '@issuemanager/apps/client/components';
import { DateFilter } from '../../../../components/filters/date-filter';
import { IssueGridFilterModel } from './types';

export function IssueGridCreatedFilter() {
  const context = useDataGridContext();

  const { createdAt: issueCreatedAt, actionCreatedAt }: IssueGridFilterModel =
    context.filterModel;

  const handleChange = useEventCallback((value: DateRange<Date>) => {
    context.setFilterModel({
      ...context.filterModel,
      createdAt: value,
      actionCreatedAt: value,
    });
  });

  const value: DateRange<Date> = [
    issueCreatedAt?.[0] ?? actionCreatedAt?.[0] ?? null,
    issueCreatedAt?.[1] ?? actionCreatedAt?.[1] ?? null,
  ];

  return <DateFilter onChange={handleChange} value={value} />;
}
